import { useState } from 'react';
import {
  Box,
  TextField,
  Typography,
  Paper,
  Button,
  IconButton,
  List,
  ListItem,
  ListItemText,
  ListItemSecondaryAction,
} from '@mui/material';
import AddIcon from '@mui/icons-material/Add';
import DeleteIcon from '@mui/icons-material/Delete';
import ProjectSelector from '../ProjectSelector';
import ArtifactTypeSelector from '../../../../components/ArtifactTypeSelector';

function TextEntry({ artifactType, onArtifactTypeChange, onDocumentIngestion, selectedProject, onProjectSelect }) {
  const [title, setTitle] = useState('');
  const [description, setDescription] = useState('');
  const [requirements, setRequirements] = useState([]);
  const [newRequirement, setNewRequirement] = useState('');

  const handleAddRequirement = () => {
    if (newRequirement.trim()) {
      setRequirements([...requirements, newRequirement.trim()]);
      setNewRequirement('');
    }
  };

  const handleDeleteRequirement = (index) => {
    const newRequirements = requirements.filter((_, i) => i !== index);
    setRequirements(newRequirements);
  };

  const handleSubmit = async (event) => {
    event.preventDefault();
    if (title.trim() || description.trim() || requirements.length > 0) {
      onDocumentIngestion(`Text Document ${Date.now()}`);
    }
  };

  return (
    <Box sx={{ 
      minHeight: 'calc(100vh - 180px)', 
      width: '100%', 
      display: 'flex', 
      flexDirection: 'column', 
      alignItems: 'center', 
      backgroundColor: '#dee2e6',
      py: 1
    }}>
      <Box sx={{
        width: '98%',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        backgroundColor: 'navy.main',
        py: 3,
        flexGrow: 1,
        borderRadius: 2
      }}>
        <Box sx={{ width: '100%', maxWidth: 900, }}>
          <ProjectSelector 
            onProjectSelect={onProjectSelect} 
            initialValue={selectedProject}
          />
          <ArtifactTypeSelector 
            value={artifactType} 
            onChange={onArtifactTypeChange} 
          />
          <Paper sx={{ p: 3, mb: 3, backgroundColor: 'slate_gray.main' }}>
            <Typography variant="h6" gutterBottom color="text.main">
              Artifact Details
            </Typography>
            <TextField
              fullWidth
              label="Title"
              value={title}
              onChange={(e) => setTitle(e.target.value)}
              margin="normal"
              sx={{ backgroundColor: 'slate_gray.main' }}
              required
            />
            <TextField
              fullWidth
              label="Description"
              value={description}
              onChange={(e) => setDescription(e.target.value)}
              margin="normal"
              multiline
              rows={4}
              sx={{ backgroundColor: 'slate_gray.main' }}
              required
            />
          </Paper>

          <Paper sx={{ p: 3, mb: 3, backgroundColor: 'slate_gray.main' }}>
            <Typography variant="h6" gutterBottom color="text.main">
              Requirements
            </Typography>
            <Box sx={{ display: 'flex', gap: 1, mb: 2 }}>
              <TextField
                fullWidth
                label="New Requirement"
                value={newRequirement}
                onChange={(e) => setNewRequirement(e.target.value)}
                sx={{ backgroundColor: 'slate_gray.main' }}
              />
              <IconButton
                onClick={handleAddRequirement}
                sx={{
                  bgcolor: 'gold.main',
                  color: 'text.main',
                  '&:hover': {
                    bgcolor: '#1a3a5f',
                  },
                }}
              >
                <AddIcon />
              </IconButton>
            </Box>
            <List>
              {requirements.map((requirement, index) => (
                <ListItem
                  key={index}
                  sx={{
                    bgcolor: '#FFFFFF',
                    mb: 1,
                    borderRadius: 1,
                  }}
                >
                  <ListItemText primary={requirement} />
                  <ListItemSecondaryAction>
                    <IconButton
                      edge="end"
                      onClick={() => handleDeleteRequirement(index)}
                      sx={{
                        color: '#dc3545',
                        '&:hover': {
                          bgcolor: 'rgba(220, 53, 69, 0.1)',
                        },
                      }}
                    >
                      <DeleteIcon />
                    </IconButton>
                  </ListItemSecondaryAction>
                </ListItem>
              ))}
            </List>
          </Paper>

          <Box sx={{ display: 'flex', justifyContent: 'flex-end' }}>
            <Button
              variant="contained"
              onClick={handleSubmit}
              disabled={!selectedProject || (!title.trim() && !description.trim() && requirements.length === 0)}
              sx={{
                bgcolor: '#2B5587',
                color: '#FFFFFF',
                fontWeight: 500,
                px: 4,
                py: 1,
                fontSize: '1rem',
                '&:hover': {
                  bgcolor: '#1a3a5f',
                },
                '&:active': {
                  bgcolor: '#142d4a',
                },
                '&.Mui-disabled': {
                  bgcolor: '#cccccc',
                  color: '#666666',
                },
                boxShadow: '0 2px 4px rgba(0,0,0,0.1)',
              }}
            >
              Ingest Artifact
            </Button>
          </Box>
        </Box>
      </Box>
    </Box>
  );
}

export default TextEntry; 